import React from 'react';
import type { PatientReadyMeetToast } from '../../hooks/useDoctorPatientReadyMeetHub';

type Props = {
  toasts: PatientReadyMeetToast[];
  onDismiss: (key: string) => void;
};

export function PatientReadyMeetToastStack({ toasts, onDismiss }: Props) {
  if (toasts.length === 0) return null;

  return (
    <div className="staff-patient-ready-toasts" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.key} className="staff-patient-ready-toast">
          <p className="staff-patient-ready-toast__text">
            <strong>{t.patientName}</strong> is ready in the video call
          </p>
          <button
            type="button"
            className="staff-patient-ready-toast__dismiss"
            onClick={() => onDismiss(t.key)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
